import React, { useEffect, useRef, useState } from "react";
import AccountLayout from "./AccountLayout";
import { t } from "i18next";
import moment from "moment/moment";
import { isEmpty, isEqual, startCase } from "lodash";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../../context/AuthContext";
import { apiGet } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
import { formatWithCommas } from "../../Utils/Toast";
import TransactionRecordDetail from "./TransactionRecordDetail";
import TransactionRecordFilter from "./TransactionRecordFilter";
const TransactionRecords = () => {
  const [detail, setDetail] = useState({});
  const user = useContextSelector(AuthContext, (ctx) => {
    return ctx.user;
  });
  const [data, setData] = useState([]);
  const [filter, setFilter] = useState({
    status: [],
    payment: [],
    date: "today",
    fromPeriod: moment().format("YYYY-MM-DD"),
    toPeriod: moment().format("YYYY-MM-DD"),
  });
  const prevFilterRef = useRef(filter);
  const groupByUpdatedDateWithBets = (arr) => {
    // Sort by updatedAt descending (latest first)
    const sorted = arr.sort(
      (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
    );

    // Group by date
    let grouped = sorted.reduce((acc, item) => {
      const date = new Date(item.createdAt).toISOString().split("T")[0]; // YYYY-MM-DD

      if (!acc[date]) {
        acc[date] = [];
      }

      acc[date].push(item);
      return acc;
    }, {});

    return Object.entries(grouped).map(([date, markets]) => ({
      date,
      markets,
    }));
  };

  const getData = async () => {
    try {
      // Call both APIs at the same time
      const [depositRes, withdrawRes] = await Promise.all([
        apiGet(apiPath.depositHistory, {
          fromPeriod: filter?.fromPeriod,
          toPeriod: filter?.toPeriod,
        }),
        apiGet(apiPath.withDrawHistory, {
          fromPeriod: filter?.fromPeriod,
          toPeriod: filter?.toPeriod,
        }),
      ]);

      // Extract results if both are successful
      const depositData =
        depositRes?.status === 200 && depositRes?.data?.success
          ? depositRes.data.results
          : [];

      const withdrawData =
        withdrawRes?.status === 200 && withdrawRes?.data?.success
          ? withdrawRes.data.results
          : [];

      // Merge both arrays
      const mergedData = [...depositData, ...withdrawData];

      // Optional: sort by date or apply transformation
      const grouped = groupByUpdatedDateWithBets(mergedData);

      setData(grouped);
    } catch (error) {}
  };
  // useEffect(() => {
  //   if (!isEqual(prevFilterRef.current, filter)) {
  //     prevFilterRef.current = filter;
  //     getData();
  //   }
  // }, [filter]);
  useEffect(() => {
    if (!isEmpty(user)) {
      getData();
    }
  }, [user]);
  return (
    <AccountLayout title={t("TransactionRecords")}>
      <TransactionRecordFilter
        setFilter={setFilter}
        filter={filter}
        getData={getData}
      />

      <div
        _ngcontent-serverapp-c3748548866
        className="transaction-record-list ng-tns-c3748548866-17 ng-star-inserted"
      >
        <div
          _ngcontent-serverapp-c3748548866
          className="list-title ng-tns-c3748548866-17"
        >
          <div
            _ngcontent-serverapp-c3748548866
            className="list-field type ng-tns-c3748548866-17"
          >
            {t("Type")}
          </div>
          <div
            _ngcontent-serverapp-c3748548866
            className="list-field amount ng-tns-c3748548866-17"
          >
            {t("Amount")}
          </div>
          <div
            _ngcontent-serverapp-c3748548866
            className="list-field status ng-tns-c3748548866-17"
          >
            {t("Status")}
          </div>
          <div
            _ngcontent-serverapp-c3748548866
            className="list-field time ng-tns-c3748548866-17"
          >
            {t("Time")}
          </div>
        </div>
        <app-waterfall-scroll
          _ngcontent-serverapp-c3748548866
          _nghost-serverapp-c302379289
          className="ng-tns-c3748548866-17 ng-star-inserted"
        >
          {data?.map((res) => {
            return (
              <div
                _ngcontent-serverapp-c3748548866
                className="list-group ng-tns-c3748548866-17 ng-trigger ng-trigger-staggerFadeAnimation ng-star-inserted"
              >
                <div
                  _ngcontent-serverapp-c3748548866
                  className="date-title ng-tns-c3748548866-17"
                >
                  <div
                    _ngcontent-serverapp-c3748548866
                    className="date ng-tns-c3748548866-17"
                  >
                    <i
                      _ngcontent-serverapp-c3748548866
                      className="ng-tns-c3748548866-17"
                      style={{
                        "mask-image":
                          'url("/assets/Other/icon-calendar-type02.svg")',
                      }}
                    />
                    {res?.date}
                  </div>
                  <div
                    _ngcontent-serverapp-c3748548866
                    className="time-zone ng-tns-c3748548866-17"
                  >
                    {" "}
                    GMT+5.5{" "}
                  </div>
                </div>
                <ul
                  _ngcontent-serverapp-c3748548866
                  className="list-content ng-tns-c3748548866-17 ng-trigger ng-trigger-staggerFadeAnimation"
                >
                  {res?.markets?.map((item) => {
                    return (
                      <li
                        onClick={() => setDetail(item)}
                        _ngcontent-serverapp-c3748548866
                        className="ng-tns-c3748548866-17 ng-star-inserted"
                        idx="D843638176"
                      >
                        <div
                          _ngcontent-serverapp-c3748548866
                          className="list-field type ng-tns-c3748548866-17"
                        >
                          {startCase(item?.type)}
                        </div>
                        <div
                          _ngcontent-serverapp-c3748548866
                          className="list-field amount ng-tns-c3748548866-17"
                        >
                          <i
                            id="locale-util-dicrective-1"
                            className="ng-tns-c3748548866-17"
                            style={{ display: "initial" }}
                          >
                            {formatWithCommas(item?.amount)}
                          </i>
                        </div>
                        <div
                          _ngcontent-serverapp-c3748548866
                          className={`list-field ng-tns-c3748548866-17 ${
                            item?.status == "completed"
                              ? "status-positive"
                              : "status-negative"
                          } `}
                        >
                          <div
                            _ngcontent-serverapp-c3748548866
                            className="tags ng-tns-c3748548866-17"
                          >
                            {item?.status == "Expired Payment Link"
                              ? "Expired"
                              : item?.status == "completed"
                              ? "Approved"
                              : item?.status == "requested"
                              ? "Processing"
                              : startCase(item?.status)}
                          </div>
                        </div>
                        <div
                          _ngcontent-serverapp-c3748548866
                          className="list-field time ng-tns-c3748548866-17"
                        >
                          {moment(item?.createdAt).format("HH:MM:SS")}
                        </div>
                        <div
                          _ngcontent-serverapp-c3748548866
                          className="list-arrow ng-tns-c3748548866-17 ng-star-inserted"
                          style={{
                            "mask-image":
                              'url("/assets/Other/icon-arrow-type01.svg")',
                          }}
                        />
                      </li>
                    );
                  })}
                </ul>
              </div>
            );
          })}

          <div
            _ngcontent-serverapp-c3748548866
            className="prompt ng-tns-c3748548866-17 ng-star-inserted"
            style={{ "margin-top": "20px" }}
          >
            {" "}
            －end of page－{" "}
          </div>

          <div
            _ngcontent-serverapp-c302379289
            style={{ height: "10px", visibility: "hidden" }}
          >
            {" "}
            anchor{" "}
          </div>
        </app-waterfall-scroll>
      </div>

      {!isEmpty(detail) && (
        <TransactionRecordDetail detail={detail} setDetail={setDetail} />
      )}
    </AccountLayout>
  );
};

export default TransactionRecords;
